import Icon, { IconTypes } from 'components/icon/Icon';
import Tip from 'components/tip/Tip';
import { ReactNode } from 'react';

import ErrorMessage from '../errorMessage/ErrorMessage';
import {
  CustomTip,
  Element,
  HintMessage,
  Label,
  LabelWithTipWrapper,
  LabelWrapper,
  Wrapper,
} from './FormElement.styles';

export interface FormElementProps {
  className?: string;
  children: ReactNode;
  error?: string;
  extraSpacing?: boolean;
  name: string;
  label?: string;
  labelLink?: string;
  linkHref?: string;
  hidden?: boolean;
  hint?: string;
  icon?: IconTypes;
  tooltip?: string;
}

const FormElement = ({
  className,
  children,
  error,
  extraSpacing,
  hint,
  name,
  label,
  labelLink,
  linkHref,
  hidden = false,
  icon,
  tooltip,
}: FormElementProps): JSX.Element => {
  return (
    <Wrapper extraSpacing={extraSpacing} className={className}>
      <Element hidden={hidden}>
        {label && !icon && !labelLink && (
          <LabelWithTipWrapper tooltip={tooltip}>
            <Label htmlFor={name}>{label} </Label>
            {tooltip && (
              <CustomTip icon="info" size="sm" theme="dark" tooltip={tooltip} />
            )}
          </LabelWithTipWrapper>
        )}
        {label && !icon && labelLink && (
          <LabelWrapper labelLink={labelLink}>
            <Label labelLink={labelLink}>{label}</Label>
            <a href={linkHref}>{labelLink}</a>
            {tooltip && (
              <Tip icon="info" size="sm" theme="dark" tooltip={tooltip} />
            )}
          </LabelWrapper>
        )}
        {label && icon && (
          <LabelWrapper htmlFor={name}>
            <Icon type="user" color="gray" size="sm" />
            {label}
          </LabelWrapper>
        )}
        {hint && <HintMessage>{hint}</HintMessage>}
        {children}
      </Element>
      {error && <ErrorMessage text={error} />}
    </Wrapper>
  );
};

export default FormElement;
